const C = require("../constants");

const selectRecipe = (data) => {
    return {
        type: C.RECIPE_SELECT,
        data
    }
};

export {selectRecipe};


// WEBPACK FOOTER //
// ./src/actions/RecipeSelectActions.js